import { render, staticRenderFns } from "./UploadCertificateOther.vue?vue&type=template&id=f9c41a86&"
import script from "./UploadCertificateOther.vue?vue&type=script&lang=js&"
export * from "./UploadCertificateOther.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports